import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 * 账密登入
 * @param params
 * 
*/

export const login = params => Http.post(`${baseUrl}/login`, params)

/**
 * 注册
 * @param params
 * 
*/

export const register = params => Http.post(`${baseUrl}/register`, params)

/**
 * 图形验证码
 * 
*/

export const captcha = () => Http.get(`${baseUrl}/captcha`)

/**
 * 学校列表
 * 
*/

export const schoolList = () => Http.get(`${baseUrl}/school`)